/**
 * Newsletter Popup Functionality
 * 
 * Open de popup met:
 * - class="wv-newsletter-trigger" op een element
 * - data-newsletter-popup attribuut op een element
 * - href="#newsletter" op een link
 * 
 * Of via JavaScript: whiskyNewsletterPopup.open()
 */
(function() {
    'use strict';

    const popup = document.getElementById('wv-newsletter-popup');
    if (!popup) return;

    const closeButtons = popup.querySelectorAll('[data-close-newsletter]');
    const firstFocusable = popup.querySelector('input, button, textarea, select, a[href]');
    let lastFocusedElement = null;

    // API object voor externe toegang
    window.whiskyNewsletterPopup = {
        open: openPopup,
        close: closePopup,
        toggle: togglePopup
    };

    function openPopup() {
        lastFocusedElement = document.activeElement;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('wv-popup-open');
        
        // Focus eerste invoerveld
        setTimeout(() => {
            if (firstFocusable) firstFocusable.focus();
        }, 100);
        
        document.addEventListener('keydown', onKeyDown);
    }

    function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('wv-popup-open');
        document.removeEventListener('keydown', onKeyDown);
        
        // Herstel focus
        if (lastFocusedElement) {
            lastFocusedElement.focus();
        }
    }

    function togglePopup() {
        if (popup.classList.contains('is-open')) {
            closePopup();
        } else {
            openPopup();
        }
    }

    function onKeyDown(e) {
        if (e.key === 'Escape') {
            closePopup();
        }
        
        // Tab trap binnen popup
        if (e.key === 'Tab') {
            const focusableElements = popup.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    }

    // Close button handlers
    closeButtons.forEach(btn => {
        btn.addEventListener('click', closePopup);
    });

    // Trigger handlers - class="wv-newsletter-trigger"
    document.addEventListener('click', function(e) {
        const trigger = e.target.closest('.wv-newsletter-trigger, [data-newsletter-popup]');
        if (trigger) {
            e.preventDefault();
            openPopup();
            return;
        }
        
        // href="#newsletter" links
        const link = e.target.closest('a[href="#newsletter"], a[href="#nieuwsbrief"]');
        if (link) {
            e.preventDefault();
            openPopup();
        }
    });

    // Close popup bij succesvolle form submission (CF7)
    document.addEventListener('wpcf7mailsent', function(event) {
        // Check of het formulier in de popup zit
        if (popup.contains(event.target)) {
            // Wacht even zodat success message getoond wordt
            setTimeout(() => {
                closePopup();
            }, 3000);
        }
    });

})();
